import React, {createContext, useContext, useState} from "react"
import AuthContext from "./AuthContext";
import ShowContext from "./ShowContext";
import showContext from "./ShowContext";

const PageContext = createContext()
export default PageContext

export const PageProvider =({children}) => {
const {englishText, setEnglishText, persianText, setPersianText} = useContext(showContext)
const [pageInfo, setPageInfo] = useState(() => ({
    documentId: 0,
    currentPage: 1,
    lastPage: 1
}));


    const {authTokens, BASE_URL} = useContext(AuthContext)
    const {showPage, hideMain, hideAllDocumentsDiv} = useContext(ShowContext)

    const addNewPage = async (event) => {
        event.preventDefault()
        const form = event.target
        let method
        if (form.parentElement.classList.contains("edit-page")) {
            method = "PUT"
        } else {
            method = "POST"
        }

        const imageFile = form.elements["imageUpload"].files[0]
        const englishTextContent = form.elements["englishText"].value
        const persianTextContent = form.elements["persianText"].value
        const pageNumber = form.elements["pageNumber"].value
        const documentID = form.elements["documentId"].value

        const imageFileName = imageFile.name
        const imageFileType = imageFile.type

        const result = await addPageToDB(method, documentID, imageFileName, imageFileType, englishTextContent, persianTextContent, pageNumber)
        
        if (result.success) {
            const imageUrl = result.data.image_url;
            form.reset()
            setEnglishText("")
            setPersianText("")
            await Promise.all([
                uploadToS3(imageUrl, imageFile),
            ]);
        }
        
        return result;
    }

    const updatePdf = async (documentID) => {
        try {
        const response = await fetch(`${BASE_URL}/api/update_pdf/${documentID}`, {
          method: 'GET',
            mode: "cors",
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.ok) {
            console.log("response ok")
            const responseData = await response.json()
            const documentKey = responseData.document_key
            console.log(documentKey)
        }

      } catch (error) {
        // Handle error
      }
    }


    const deletePage = async(pageInfo) => {
        const documentID = pageInfo.documentId
        const page_num = pageInfo.currentPage
        const response = await fetch (`${BASE_URL}/api/delete_page/${documentID}/${page_num}/`, {
                method: "DELETE",
                mode: "cors",
                credentials:"include",
                headers: {
                    "Authorization": "Bearer " + String(authTokens.access)
                }
        })

        const responseData = await response.json()

        //updatePdf(documentID)
    }


   async function getDocumentPage(event, documentID, page_num) {

        hideMain()
       hideAllDocumentsDiv()

        if (!documentID) {
            documentID = event.target.parentElement.parentElement.id
        }

        const response = await fetch(`${BASE_URL}/api/get_document_pages/${documentID}/${page_num}/`, {
            method: "GET",
        })
        const data = await response.json()

        if (response.ok) {
            console.log(data)
            localStorage.setItem("audioUrl", data.audio_url)
            localStorage.setItem("imageUrl", data.image_url)
            // const english_text = await getText(data.english_text_url)
            // const persian_text = await getText(data.persian_text_url)
            localStorage.setItem("english_text", data.english_text)
            localStorage.setItem("persian_text", data.persian_text)
            setPageInfo({
                currentPage: data.current_page,
                lastPage: data.last_page,
                documentId: documentID
            })
            showPage()
        }

    }


    const addPageToDB = async (method, documentID, imageFileName, imageFileType, englishTextContent, persianTextContent, pageNumber) =>{
        console.log("Add to db called")
        try {
        const response = await fetch(`${BASE_URL}/api/add_page/`, {
          method: method,
          headers: {
            'Content-Type': 'application/json',
              "Authorization": "Bearer " + String(authTokens.access)
          },
            body: JSON.stringify({
                documentid: documentID,
                pagenumber: pageNumber,
              image: {
                  filename: imageFileName,
                  filetype: imageFileType
              },
              english_text: englishTextContent,
              persian_text: persianTextContent
            }),
        });
            const responseData = await response.json()
            
            if (response.ok) {
                return { 
                    success: true, 
                    message: responseData.message || "Page added successfully",
                    data: responseData
                }
            } else {
                return { 
                    success: false, 
                    message: responseData.message || "Failed to add page",
                    data: responseData
                }
            }

      } catch (error) {
        console.error('Fetch error:', error);
        return { 
            success: false, 
            message: "Network error occurred while adding page",
            data: null
        }
      }
    };



    const uploadToS3 = async (presignedUrl, file) =>{
        const response = await fetch(presignedUrl, {
            method: "PUT",
            body: file,
            headers: {
                'Content-Type': file.type,
                },
        })
        if (response.ok) {
          console.log('File uploaded successfully');
        } else {
          console.error('Failed to upload file:', response.statusText);
        }

        console.log(presignedUrl, file.type)
    }
    //
    // const getText = async (presignedUrl) =>{
    //     const response = await fetch(presignedUrl, {
    //         method: "GET",
    //     })
    //
    //     if (response.ok) {
    //         return await response.text()
    //     }
    //
    // }

        let contextData ={
            pageInfo:pageInfo,
            englishText:englishText,
            setEnglishText:setEnglishText,
            persianText:persianText,
            setPersianText:setPersianText,
            getDocumentPage:getDocumentPage,
            deletePage:deletePage,
            addNewPage:addNewPage
        }

        return(
        <PageContext.Provider value={contextData}>
            {children}
        </PageContext.Provider>
    )

}